import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import SubBanner from "../../../components/SubBanner";
import bannerImg from "../../../assets/img/resources_banner.png";
import { BOARD_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";

function Notice(){
   // 0: Notice, 1: FAQ, 2: 자료실, 3:Blog
  const [activeTab, setActiveTab] = useState(0);
  const [data, setData] = useState([]);
  const [topData, setTopData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  
  const itemsPerPage = 10; // 한 페이지당 보여줄 게시글 수
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  // 배너 탭
  const tabList = [
    { label : 'Notice', url : '/resources/notice'},
    { label : 'FAQ', url : '/resources/faq'},
    { label : '자료실', url : '/resources/data'},
    { label : 'Blog', url : '/resources/blog'},
  ]

  // 게시판 데이터 가져오기
  const fetchBoardList = async (page = 1, search = '') => {
    try{
      const response = await instance.post(BOARD_LIST_URL, {
        boardid: 'notice',
        offset: page.toString(),
        searchText: search
      });
      setData(response.data.data.data);
      setTopData(response.data.data.topData);
      setTotalCount(parseInt(response.data.data.cntRow));
    } catch (error) {
      console.error('게시판 목록 조회 오류:', error);
    }
  };

  useEffect(() => {
    fetchBoardList(currentPage, ''); // 초기 로드 시에는 검색어 없이
  }, [currentPage]); // searchText 의존성 제거

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // 페이지 변경 시에는 현재 검색어로 API 호출
      fetchBoardList(page, searchText);
    }
  };

  // 검색 핸들러 - 검색 버튼 클릭 시에만 API 호출
  const handleSearch = () => {
    setCurrentPage(1); // 검색 시 첫 페이지로
    fetchBoardList(1, searchText);
  };

  // 검색어 삭제 핸들러
  const handleClearSearch = () => {
    setSearchText('');
    setCurrentPage(1);
    fetchBoardList(1, '');
  };

  // 페이지네이션 번호 생성 (현재 페이지 기준으로 5개씩 표시)
  const getPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);
    
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  return(
    <div className="resources">
    {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        title= {'Notice'}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Resources", url: "/resources" },
          { label: "Notice", url: "/resources/notice", active: true }
        ]}
      />

      <section className="sub_section mt-[180px] md:mt-[210px] mb-[120px] mx-auto">
          {/* 검색창 */}
          <div className="flex items-center justify-end">
            <div className="srch_box">
              <label htmlFor="form_search" className="blind">검색어 입력</label>
              <input 
                type="text" 
                id="form_search" 
                placeholder="제목 또는 내용을 검색해주세요" 
                className="focus:border-[#F84343] focus:outline-none"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleSearch();
                  }
                }}
              />
              <button 
                type="button" 
                className="absolute right-[55px] top-1/2 -translate-y-1/2"
                onClick={handleClearSearch}
              >
                <i className="icon icon_delete">검색어 삭제</i>
              </button>
              <button 
                type="button" 
                className="absolute right-[15px] top-1/2 -translate-y-1/2"
                onClick={handleSearch}
              >
                <i className="icon icon_srch">검색하기</i>
              </button>
            </div>
          </div>

          {/* 게시판 */}
          <div className="notice_container w-full mx-auto mt-[24px]">
            <table className="w-full text-center border-separate table-fixed">
              <thead>
                <tr className="bg-[#F4F5F6]">
                  <th className="hidden md:table-cell w-0 md:w-[11%]">No.</th>
                  <th >제목</th>
                  <th className="w-[50px] md:w-[13%]">첨부파일</th>
                  <th className="w-[120px]  md:w-[12%]">작성일</th>
                </tr>
              </thead>
              <tbody>
                {/* 상단 고정 공지사항 (topData) - 단일 객체 */}
                {/* topData가 빈 배열이 아니고 객체일 때만 보이게 */}
                {topData && Object.keys(topData).length > 0 && (
                  <tr key={`top-${topData?.b_seq}`} className="bg-white h-[65px]">
                    <td className="hidden md:table-cell w-0 md:w-[11%]">
                      <span className="notice_badge">공지</span>
                    </td>
                    <td className="a_link text-left ">
                      <Link to={`/resources/notice/noticeDetail/${topData?.b_seq}`}>
                        <span className="pl-[10px] md:pl-[60px] ellipsis">{topData?.subject}</span>
                      </Link>
                    </td>
                    <td>
                      <div className="flex justify-center items-center">
                        {topData?.file_count && parseInt(topData?.file_count) > 0 && (
                            <i className="icon icon_clip"></i>
                        )}
                        </div>
                    </td>
                    <td>
                      <p className="notice_date">{topData?.regist_date?.split(' ')[0]}</p>
                    </td>
                  </tr>
                )}
                
                {/* 일반 게시글 (data) */}
                {data.map((row, idx) => (
                  <tr key={`data-${idx}`} className="bg-white h-[65px]">
                    <td className="hidden md:table-cell w-0 md:w-[11%]">
                      <span className="notice_num">{totalCount - idx}</span>
                    </td>
                    <td className="a_link text-left ">
                      <Link to={`/resources/notice/noticeDetail/${row?.b_seq}`}>
                        <span className="pl-[10px] md:pl-[60px] ellipsis">{row?.subject}</span>
                      </Link>
                    </td>
                    <td>
                      <div className="flex justify-center items-center">
                        {row?.file_count && parseInt(row?.file_count) > 0 && (
                            <i className="icon icon_clip"></i>
                        )}
                        </div>
                    </td>
                    <td>
                      <p className="notice_date">{row?.regist_date?.split(' ')[0]}</p>
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {/* Pagination */}
            <div className="flex justify-center items-center gap-[8px] mt-[50px] md:mt-[80px]">
              {/* 첫 페이지 */}
              <button 
                type="button" 
                className="page pg_first"
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              ></button>
              
              {/* 이전 페이지 */}
              <button 
                type="button" 
                className="page pg_prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              ></button>
              
              {/* 페이지 번호들 */}
              {getPageNumbers().map((num) => (
                <button
                  key={num}
                  className={`page_num w-[36px] h-[36px] rounded-[8px] ${
                    num === currentPage ? "bg-[#F84343] text-white" : "text-[#999]"
                  }`}
                  onClick={() => handlePageChange(num)}
                >
                  {num}
                </button>
              ))}
              
              {/* 다음 페이지 */}
              <button 
                type="button" 
                className="page pg_next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              ></button>
              
              {/* 마지막 페이지 */}
              <button 
                type="button" 
                className="page pg_last"
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              ></button>
            </div>
          </div>

      </section> 
    </div>
  )
};

export default Notice;